export default {
  FORWARDER: 'enterprise/forwarder.html',
  INPUT_PROFILE: 'enterprise/forwarder.html#input-profile',
};
